export enum TYPE {
  HOME = 'home',
  RESERVATION = 'reservation',
}
